import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ActivitiService from "../../services/activity.service"

export const getActivity = createAsyncThunk(
  "Activity/getActivity",
  async (payload, thunkAPI) => {
    try {
      const response = await ActivitiService.getActivity(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addActivity = createAsyncThunk(
  "Activity/addActivity",
  async (data, thunkAPI) => {
    try {
      const response = await ActivitiService.addActivity(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);



export const deleteActivity = createAsyncThunk(
  "Activity/deleteActivity",
  async (id, thunkAPI) => {
    try {
      const response = await ActivitiService.deleteActivity(id);
      return id; 
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  activitylist: [],
  updateSuccess: false,
};

/* =================== Slice =================== */

const activitySlice = createSlice({
  name: "activity",
  initialState,

  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ---------- Get diarynote ---------- */
      .addCase(getActivity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getActivity.fulfilled, (state, action) => {
        state.loading = false;
        state.activitylist = action.payload?.data || [];
      })
      .addCase(getActivity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add diarynote ---------- */
      .addCase(addActivity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addActivity.fulfilled, (state, action) => {
        state.loading = false;
        state.activitylist.unshift(action.payload?.data);
      })
      .addCase(addActivity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export const { resetUpdateStatus } = activitySlice.actions;
export default activitySlice.reducer;
